angular.module("acl.metrics.renameMetricPrompt", []);
